(() => {
  if (window.maxSportsUXInitialized) return;
  window.maxSportsUXInitialized = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const main = document.querySelector('#MainContent[data-template="product"]');
  const strings = window.maxSportsCROStrings;
  const productEnabled = Boolean(main && strings);
  let sticky;
  let syncProduct = () => {};
  let recordCloneMutations = () => {};
  let pendingFrame = 0;

  const isRendered = (element) => {
    if (!element || element.closest('[hidden], details:not([open])')) return false;
    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' &&
      style.visibility !== 'collapse' && element.getClientRects().length > 0;
  };

  const setClass = (element, name, enabled) => {
    if (element.classList.contains(name) !== enabled) element.classList.toggle(name, enabled);
  };

  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const setText = (element, value) => {
    if (element.textContent !== value) element.textContent = value;
  };

  const themeOverlayOpen = () => {
    if (document.body.classList.contains('overflow-hidden')) return true;
    const selector = [
      'header details[open]',
      'header-drawer > details[open]',
      'menu-drawer > details[open]',
      'details-modal > details[open]',
      'modal-dialog[open]',
      'product-modal[open]',
      'quick-add-modal[open]',
      'dialog[open]',
      'cart-drawer.active',
      '#cart-notification.active',
      'pickup-availability-drawer[open]',
      '[role="dialog"][aria-modal="true"]'
    ].join(',');
    return Array.from(document.querySelectorAll(selector)).some((element) => {
      if (!isRendered(element) || element.closest([
        'pickup-availability-drawer:not([open])',
        'modal-dialog:not([open])',
        'product-modal:not([open])',
        'quick-add-modal:not([open])',
        'dialog:not([open])'
      ].join(','))) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < window.innerWidth &&
        rect.bottom > 0 && rect.top < window.innerHeight;
    });
  };

  const sync = () => {
    pendingFrame = 0;
    const overlayOpen = themeOverlayOpen();
    const chatOpen = Boolean(document.querySelector('shopify-chat[open]'));
    const rewards = document.querySelector('#bon-iframe-container');
    const rewardsRect = rewards && rewards.getBoundingClientRect();
    const rewardsOpen = Boolean(isRendered(rewards) && rewardsRect.width > 0 && rewardsRect.height > 0 &&
      rewardsRect.right > 0 && rewardsRect.left < window.innerWidth &&
      rewardsRect.bottom > 0 && rewardsRect.top < window.innerHeight);
    const rewardsButton = document.querySelector('#bon-loyalty-btn');
    const rewardsLabel = rewardsButton && rewardsButton.querySelector('span')?.textContent.trim();
    if (rewardsLabel) setAttribute(rewardsButton, 'aria-label', rewardsLabel);
    setClass(document.body, 'maxsports-overlay-open', overlayOpen);
    setClass(document.body, 'maxsports-chat-open', chatOpen);
    setClass(document.body, 'maxsports-rewards-open', rewardsOpen);
    syncProduct(overlayOpen || chatOpen || rewardsOpen);

    const stickyActive = Boolean(sticky && !sticky.hidden);
    setClass(document.body, 'maxsports-sticky-active', stickyActive);
    const height = stickyActive ? Math.ceil(sticky.getBoundingClientRect().height) : 0;
    const clearance = height + 'px';
    if (document.body.style.getPropertyValue('--maxsports-fixed-action-height') !== clearance) {
      document.body.style.setProperty('--maxsports-fixed-action-height', clearance);
    }
    let launcherClearance = height;
    if (mobile.matches && productEnabled && !stickyActive) {
      main.querySelectorAll('.product-form__submit').forEach((button) => {
        if (!isRendered(button)) return;
        const rect = button.getBoundingClientRect();
        if (rect.width > 0 && rect.right > 0 && rect.left < window.innerWidth &&
          rect.top < window.innerHeight && rect.bottom > window.innerHeight - 80) {
          launcherClearance = Math.max(launcherClearance, Math.ceil(window.innerHeight - rect.top));
        }
      });
    }
    const launcherOffset = launcherClearance + 'px';
    if (document.body.style.getPropertyValue('--maxsports-launcher-clearance') !== launcherOffset) {
      document.body.style.setProperty('--maxsports-launcher-clearance', launcherOffset);
    }
  };

  const scheduleSync = () => {
    if (!pendingFrame) pendingFrame = window.requestAnimationFrame(sync);
  };

  if (productEnabled) {
    document.body.classList.add('maxsports-product-page');
    const guides = new WeakMap();
    const stringStockSelectors = ['133292', '134455', '135024'].map((id) =>
      '.gpo-app[data-option-set-id="' + id + '"] .gpo-element[data-element-id="select-1"] select[data-type="select"]'
    ).join(',');
    const stringOptionLocks = new WeakMap();
    const stringOptionOwners = new Map();
    const trackedStringOptions = new Set();
    const paymentLocks = new WeakMap();
    const paymentOwners = new Map();
    const pendingOptionDisabled = new WeakMap();
    const pendingPaymentInert = new WeakMap();
    const stockMessages = new Map();
    let nextStringStockOwner = 0;
    let nextStringStockMessage = 0;
    let nextPaymentStockOwner = 0;

    const variantId = (option) => {
      const id = option && option.getAttribute('gpo-data-variant-id');
      return id && /^\d+$/.test(id) ? id : '';
    };

    const addonAvailability = () => {
      const variants = window.GPOConfigs && window.GPOConfigs.addonVariants;
      const result = new Map();
      if (!Array.isArray(variants)) return result;
      variants.forEach((variant) => {
        if (!variant || typeof variant.available !== 'boolean') return;
        const id = String(variant.id);
        if (!/^\d+$/.test(id)) return;
        if (result.has(id) && result.get(id) !== variant.available) result.set(id, undefined);
        else if (!result.has(id)) result.set(id, variant.available);
      });
      return result;
    };

    const recordStockMutations = (mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'disabled') {
          const lock = stringOptionLocks.get(mutation.target);
          if (lock) lock.owner.appDisabled = mutation.target.disabled;
          else if (mutation.target instanceof HTMLOptionElement) pendingOptionDisabled.set(mutation.target, mutation.target.disabled);
        } else if (mutation.attributeName === 'inert') {
          const lock = paymentLocks.get(mutation.target);
          if (lock) lock.appInert = mutation.target.hasAttribute('inert');
          else pendingPaymentInert.set(mutation.target, mutation.target.hasAttribute('inert'));
        }
      });
    };

    const stockObserver = new MutationObserver((mutations) => {
      recordStockMutations(mutations);
      scheduleSync();
    });
    stockObserver.observe(main, {
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['disabled', 'inert']
    });

    const ownedStockWrite = (target, attribute, write) => {
      recordStockMutations(stockObserver.takeRecords());
      write();
      let ownRecord = true;
      recordStockMutations(stockObserver.takeRecords().filter((mutation) => {
        if (ownRecord && mutation.target === target && mutation.attributeName === attribute) {
          ownRecord = false;
          return false;
        }
        return true;
      }));
    };

    const newStringOptionOwner = (option, state) => {
      let id;
      do { id = 'string-' + ++nextStringStockOwner; } while (stringOptionOwners.has(id));
      const owner = { ...state };
      stringOptionOwners.set(id, owner);
      setAttribute(option, 'data-maxsports-string-stock-owner', id);
      return owner;
    };

    const optionLock = (option, id) => {
      let lock = stringOptionLocks.get(option);
      if (lock && lock.id !== id) {
        if (option.disabled !== lock.owner.appDisabled) {
          ownedStockWrite(option, 'disabled', () => { option.disabled = lock.owner.appDisabled; });
        }
        option.removeAttribute('data-maxsports-string-stock-owner');
        stringOptionLocks.delete(option);
        lock = undefined;
      }
      if (!lock && option.hasAttribute('data-maxsports-string-stock-owner')) {
        const inherited = stringOptionOwners.get(option.getAttribute('data-maxsports-string-stock-owner'));
        if (inherited) {
          const state = { ...inherited, appDisabled: pendingOptionDisabled.has(option)
            ? pendingOptionDisabled.get(option) : inherited.appDisabled };
          if (inherited.id === id) {
            lock = { id, owner: newStringOptionOwner(option, state), unavailable: inherited.unavailable };
            stringOptionLocks.set(option, lock);
            trackedStringOptions.add(option);
          } else {
            if (option.disabled !== state.appDisabled) ownedStockWrite(option, 'disabled', () => { option.disabled = state.appDisabled; });
            option.removeAttribute('data-maxsports-string-stock-owner');
          }
          pendingOptionDisabled.delete(option);
        }
      }
      return lock;
    };

    const stockMessage = (select, unavailable, invalid) => {
      const field = select.closest('.gpo-element');
      if (!field) return;
      let message = stockMessages.get(select);
      if (!message && !unavailable && !invalid) return;
      if (!message || !message.isConnected) {
        message = document.createElement('p');
        do { message.id = 'maxsports-string-stock-' + ++nextStringStockMessage; }
        while (document.getElementById(message.id));
        message.className = 'maxsports-string-stock-message';
        message.setAttribute('role', 'status');
        message.setAttribute('aria-live', 'polite');
        field.append(message);
        stockMessages.set(select, message);
      }
      const visible = unavailable || invalid;
      setText(message, invalid ? strings.stringSelectionUnavailable : strings.stringChoicesUnavailable);
      if (message.hidden !== !visible) message.hidden = !visible;
      const describedBy = new Set((select.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      if (visible) describedBy.add(message.id);
      else describedBy.delete(message.id);
      if (describedBy.size) setAttribute(select, 'aria-describedby', Array.from(describedBy).join(' '));
      else if (select.hasAttribute('aria-describedby')) select.removeAttribute('aria-describedby');
    };

    const stringStockRoot = (element) => element && element.closest('product-info') || main;

    const selectedStringUnavailable = (owner) => Array.from(main.querySelectorAll(stringStockSelectors)).find((select) => {
      if (select.disabled || !isRendered(select) || owner && stringStockRoot(select) !== owner) return false;
      const selected = select.options[select.selectedIndex];
      const lock = selected && stringOptionLocks.get(selected);
      return lock && lock.id === variantId(selected) && lock.unavailable;
    });

    const syncStringStock = () => {
      recordStockMutations(stockObserver.takeRecords());
      trackedStringOptions.forEach((option) => {
        const select = option.closest('select');
        if (main.contains(option) && select && select.matches(stringStockSelectors)) return;
        const lock = stringOptionLocks.get(option);
        if (option.isConnected && lock && option.disabled !== lock.owner.appDisabled) {
          ownedStockWrite(option, 'disabled', () => { option.disabled = lock.owner.appDisabled; });
        }
        if (option.isConnected) option.removeAttribute('data-maxsports-string-stock-owner');
        stringOptionLocks.delete(option);
        trackedStringOptions.delete(option);
      });
      stockMessages.forEach((message, select) => {
        if (main.contains(select) && select.matches(stringStockSelectors)) return;
        const describedBy = (select.getAttribute('aria-describedby') || '').split(/\s+/)
          .filter((id) => id && id !== message.id);
        if (describedBy.length) setAttribute(select, 'aria-describedby', describedBy.join(' '));
        else if (select.hasAttribute('aria-describedby')) select.removeAttribute('aria-describedby');
        message.remove();
        stockMessages.delete(select);
      });
      const availability = addonAvailability();
      main.querySelectorAll(stringStockSelectors).forEach((select) => {
        let unavailable = false;
        Array.from(select.options).forEach((option) => {
          const id = variantId(option);
          let lock = optionLock(option, id);
          const state = id ? availability.get(id) : undefined;
          if (state === false && !lock) {
            const owner = newStringOptionOwner(option, { id, appDisabled: option.disabled, unavailable: true });
            lock = { id, owner, unavailable: true };
            stringOptionLocks.set(option, lock);
            trackedStringOptions.add(option);
            pendingOptionDisabled.delete(option);
          }
          if (!lock) return;
          if (state === true) lock.unavailable = false;
          else if (state === false) lock.unavailable = true;
          lock.owner.unavailable = lock.unavailable;
          const disabled = lock.owner.appDisabled || lock.unavailable;
          if (option.disabled !== disabled) ownedStockWrite(option, 'disabled', () => { option.disabled = disabled; });
          unavailable = unavailable || lock.unavailable;
        });
        const selected = select.options[select.selectedIndex];
        const selectedLock = selected && stringOptionLocks.get(selected);
        stockMessage(select, unavailable, Boolean(selectedLock && selectedLock.unavailable));
      });
      const activeOwners = new Set(Array.from(main.querySelectorAll('option[data-maxsports-string-stock-owner]'))
        .map((option) => option.getAttribute('data-maxsports-string-stock-owner')));
      stringOptionOwners.forEach((owner, id) => { if (!activeOwners.has(id)) stringOptionOwners.delete(id); });
      main.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach((payment) => {
        const invalid = Boolean(selectedStringUnavailable(stringStockRoot(payment)));
        let lock = paymentLocks.get(payment);
        const inherited = !lock && paymentOwners.get(payment.getAttribute('data-maxsports-string-payment-owner'));
        if (!lock && (invalid || inherited)) {
          let ownerId;
          do { ownerId = 'payment-' + ++nextPaymentStockOwner; } while (paymentOwners.has(ownerId));
          lock = { appInert: pendingPaymentInert.has(payment) ? pendingPaymentInert.get(payment)
            : inherited ? inherited.appInert : payment.hasAttribute('inert') };
          paymentLocks.set(payment, lock);
          paymentOwners.set(ownerId, lock);
          setAttribute(payment, 'data-maxsports-string-payment-owner', ownerId);
          pendingPaymentInert.delete(payment);
        }
        if (!lock) return;
        const inert = invalid || lock.appInert;
        if (payment.hasAttribute('inert') !== inert) {
          ownedStockWrite(payment, 'inert', () => { payment.toggleAttribute('inert', inert); });
        }
        setClass(payment, 'maxsports-string-stock-payment-blocked', invalid);
      });
      const activePayments = new Set(Array.from(main.querySelectorAll('[data-maxsports-string-payment-owner]'))
        .map((payment) => payment.getAttribute('data-maxsports-string-payment-owner')));
      paymentOwners.forEach((owner, id) => { if (!activePayments.has(id)) paymentOwners.delete(id); });
    };

    const blockUnavailableString = (event, control) => {
      syncStringStock();
      const owner = sticky && sticky.contains(control) ? currentButton() : control;
      const select = selectedStringUnavailable(stringStockRoot(owner));
      if (!select) return false;
      event.preventDefault();
      event.stopImmediatePropagation();
      select.focus();
      const message = stockMessages.get(select);
      if (message) setText(message, strings.stringSelectionUnavailable);
      scheduleSync();
      return true;
    };

    document.addEventListener('click', (event) => {
      const control = event.target.closest && event.target.closest(
        '.product-form__submit, .gpo-clone-atc-button, .shopify-payment-button, shopify-accelerated-checkout, .maxsports-sticky-atc__button'
      );
      if (control && (main.contains(control) || sticky && sticky.contains(control))) blockUnavailableString(event, control);
    }, true);
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && main.contains(form) &&
        (form.closest('product-form') || form.querySelector('.product-form__submit'))) blockUnavailableString(event, form);
    }, true);
    document.addEventListener('gpoRenderCompleted', scheduleSync);

    const optionLabel = (option) => option.text.trim().replace(
      /\s*\(\s*[+−-]?\s*(?:(?:CA\$|C\$|US\$|\$|€|£|¥|CAD|USD|EUR)\s*[\d.,\s]+|[\d.,\s]+\s*(?:CAD|USD|EUR|GBP|CNY))\s*\)\s*$/i,
      ''
    ).trim();

    const parseChoice = (text, isString) => {
      if (isString) {
        const match = text.match(/^(.+?)\s*\(([\p{L}\s/-]+)\)$/u);
        return match && { model: match[1].trim(), color: match[2].trim() };
      }
      const pack = text.match(/^(.+?)-\s*([\p{L}\s/-]+?)\s+(\d+\s*(?:Pack|Wraps))$/iu);
      if (pack) return { model: pack[1].trim() + ' (' + pack[3].trim() + ')', color: pack[2].trim() };
      const wraps = text.match(/^(.+?)\s+\((\d+\s*(?:Pack|Wraps))\)\s+([\p{L}\s/-]+)$/iu);
      if (wraps) return { model: wraps[1].trim() + ' (' + wraps[2].trim() + ')', color: wraps[3].trim() };
      const single = text.match(/^(.+?)-\s*([\p{L}\s/-]+)$/u);
      return single && { model: single[1].trim(), color: single[2].trim() };
    };

    const addChoiceGuide = (select) => {
      const field = select.closest('.gpo-element');
      const name = select.name || select.getAttribute('aria-label') || '';
      const isFactoryString = /replace\s+factory\s+string/i.test(name);
      const isString = /string add-on/i.test(name) || isFactoryString;
      const isGrip = /grip add-on/i.test(name);
      if (!field || (!isString && !isGrip)) return;
      const previous = guides.get(field);
      if (previous && previous.select === select) {
        previous.refresh();
        return;
      }
      if (previous) previous.details.remove();

      const details = document.createElement('details');
      details.className = 'maxsports-choice-guide';
      const summary = document.createElement('summary');
      summary.textContent = strings.needHelp;
      const body = document.createElement('div');
      body.className = 'maxsports-choice-guide__body';
      const help = document.createElement('p');
      help.textContent = isString ? strings.stringHelp : strings.gripHelp;
      const chips = document.createElement('div');
      chips.className = 'maxsports-choice-guide__chips';
      const controls = document.createElement('div');
      controls.className = 'maxsports-choice-guide__controls';
      const status = document.createElement('p');
      status.className = 'maxsports-choice-guide__status';
      status.setAttribute('aria-live', 'polite');
      body.append(help, chips, controls, status);
      details.append(summary, body);
      field.insertBefore(details, field.firstChild);

      let entries = [];
      let filter = '';
      let modelSelect;
      let colorSelect;
      let colorLabel;
      let searchInput;
      let resultSelect;
      let mode = '';
      let lastSignature = '';
      let lastOptions = [];
      let lastValue;
      const groups = isString
        ? [['all', strings.allStrings, ''], ['durability', strings.durability, 'durability'],
          ['repulsion', strings.repulsion, 'repulsion'], ['control', strings.control, 'control'],
          ['none', isFactoryString ? strings.keepOriginalString : strings.noString, '__none__']]
        : [['all', strings.allGrips, ''], ['single', strings.singleWraps, 'single'],
          ['multipack', strings.multiPacks, '__multipack__'], ['other', strings.otherPacks, '__other__'],
          ['none', strings.noGrip, '__none__']];

      const option = (label, value, disabled = false) => {
        const element = document.createElement('option');
        element.textContent = label;
        element.value = value;
        element.disabled = disabled;
        return element;
      };

      const available = (entry) => !entry.original.disabled && !entry.original.hidden;
      const modelEntries = (model) => entries.filter((entry) => entry.model === model);
      const matchesFilter = (entry) => {
        if (!filter || entry.neutral) return true;
        if (filter === '__none__') return false;
        if (filter === '__multipack__') return /\b\d+\s*(?:pack|wraps)\b/i.test(entry.model);
        if (filter === '__other__') return !/\bsingle\b|\b\d+\s*(?:pack|wraps)\b/i.test(entry.model);
        return entry.model.toLowerCase().includes(filter);
      };

      const populateColors = (model, selectedColor = '') => {
        colorSelect.replaceChildren(option(strings.chooseColor, ''));
        const choices = modelEntries(model).filter((entry) => !entry.neutral);
        choices.forEach((entry) => colorSelect.append(option(entry.color, entry.color, !available(entry))));
        colorSelect.value = selectedColor;
        colorLabel.hidden = !choices.length;
      };

      const populateModels = (selectedModel = '') => {
        modelSelect.replaceChildren(option(strings.chooseModel, ''));
        const models = [...new Set(entries.filter(matchesFilter).map((entry) => entry.model))];
        models.forEach((model) => modelSelect.append(option(model, model, !modelEntries(model).some(available))));
        modelSelect.value = models.includes(selectedModel) ? selectedModel : '';
        populateColors(modelSelect.value);
      };

      const applyOriginalChoice = (entry) => {
        if (!entry || !available(entry)) return;
        // Bind to the original option node even when the app has duplicate display labels or values.
        select.selectedIndex = entry.original.index;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };

      const searchText = (text) => text.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLowerCase().replace(/\s+/g, ' ').trim();
      const populateResults = () => {
        const terms = searchText(searchInput.value).split(' ').filter(Boolean);
        const matches = entries.filter((entry) => terms.every((term) =>
          searchText(entry.original.value + ' ' + entry.original.text).includes(term)));
        resultSelect.replaceChildren(option(strings.chooseExactChoice, ''));
        matches.forEach((entry) => resultSelect.append(option(entry.original.text, String(entry.original.index), !available(entry))));
        const selected = select.options[select.selectedIndex];
        resultSelect.value = matches.some((entry) => entry.original === selected) ? String(selected.index) : '';
        setText(status, strings.searchResults.replace('[count]', String(matches.length)) + ' ' + strings.retainedSelection);
      };

      const clearControls = () => {
        controls.replaceChildren();
        chips.replaceChildren();
        modelSelect = undefined;
        colorSelect = undefined;
        searchInput = undefined;
        resultSelect = undefined;
      };

      const refresh = (force = false) => {
        const signature = JSON.stringify(Array.from(select.options).map((entry) =>
          [entry.value, entry.text, entry.disabled, entry.hidden, entry.getAttribute('gpo-data-variant-id')]));
        const options = Array.from(select.options);
        const sameOptions = options.length === lastOptions.length && options.every((entry, index) => entry === lastOptions[index]);
        if (!force && signature === lastSignature && select.value === lastValue && sameOptions) return;
        lastOptions = options;
        lastSignature = signature;
        lastValue = select.value;
        const parsed = Array.from(select.options).filter((original) => original.value !== '').map((original) => {
          const label = optionLabel(original);
          const neutral = /^(no string|none|keep original string)$/i.test(original.value.trim()) ||
            /^(no string|none|keep original string)$/i.test(label) || original.value === '' ||
            label === strings.noString || label === strings.noGrip;
          if (neutral) return { model: label, color: '', neutral: true, original };
          const choice = parseChoice(original.value.trim(), isString) || parseChoice(label, isString);
          return choice && { ...choice, original, neutral: false };
        });
        const keys = parsed.filter(Boolean).map((entry) => entry.model + '\u0000' + entry.color);
        const canGroup = parsed.length > 1 && parsed.every(Boolean) && new Set(keys).size === keys.length &&
          ['modelLabel', 'colorLabel', 'chooseModel', 'chooseColor', 'keepSelection', 'retainedSelection']
            .every((key) => Boolean(strings[key]));
        const canSearch = parsed.length > 1 && ['searchChoices', 'chooseExactChoice', 'searchResults', 'retainedSelection']
          .every((key) => Boolean(strings[key]));
        const nextMode = canGroup ? 'group' : canSearch ? 'search' : '';
        if (mode !== nextMode) {
          clearControls();
          mode = nextMode;
          filter = '';
        }
        controls.hidden = !nextMode;
        chips.hidden = !canGroup;
        if (!canGroup) {
          // Unknown formats remain exact choices; never infer model, gauge, colour or packaging.
          entries = Array.from(select.options).filter((original) => original.value !== '').map((original) => ({ original }));
          if (!canSearch) {
            setText(status, '');
            return;
          }
          if (!searchInput) {
            setText(help, strings.searchHelp);
            const searchLabel = document.createElement('label');
            searchLabel.append(document.createTextNode(strings.searchChoices));
            searchInput = document.createElement('input');
            searchInput.type = 'search';
            searchInput.className = 'maxsports-choice-guide__search';
            searchInput.autocomplete = 'off';
            searchInput.setAttribute('aria-label', strings.searchChoices);
            searchLabel.append(searchInput);
            const resultLabel = document.createElement('label');
            resultLabel.append(document.createTextNode(strings.exactChoice));
            resultSelect = document.createElement('select');
            resultSelect.className = 'maxsports-choice-guide__results';
            resultSelect.setAttribute('aria-label', strings.exactChoice);
            resultLabel.append(resultSelect);
            controls.append(searchLabel, resultLabel);
            searchInput.addEventListener('input', populateResults);
            resultSelect.addEventListener('change', () => {
              if (resultSelect.value === '') return;
              applyOriginalChoice(entries.find((entry) => String(entry.original.index) === resultSelect.value));
            });
          }
          populateResults();
          return;
        }
        entries = parsed;
        setText(help, isString ? strings.stringHelp : strings.gripHelp);
        if (!modelSelect) {
          const modelLabel = document.createElement('label');
          modelLabel.append(document.createTextNode(strings.modelLabel));
          modelSelect = document.createElement('select');
          modelSelect.className = 'maxsports-choice-guide__model';
          modelSelect.setAttribute('aria-label', strings.modelLabel);
          modelLabel.append(modelSelect);
          colorLabel = document.createElement('label');
          colorLabel.append(document.createTextNode(strings.colorLabel));
          colorSelect = document.createElement('select');
          colorSelect.className = 'maxsports-choice-guide__color';
          colorSelect.setAttribute('aria-label', strings.colorLabel);
          colorLabel.append(colorSelect);
          controls.append(modelLabel, colorLabel);
          groups.forEach(([key, label, choiceFilter], index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'maxsports-choice-guide__chip';
            button.textContent = label;
            button.dataset.group = key;
            button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
            button.addEventListener('click', () => {
              filter = choiceFilter;
              populateModels();
              chips.querySelectorAll('button').forEach((chip) =>
                setAttribute(chip, 'aria-pressed', chip === button ? 'true' : 'false'));
              setText(status, strings.retainedSelection);
            });
            chips.append(button);
          });
          modelSelect.addEventListener('change', () => {
            const model = modelSelect.value;
            const neutral = modelEntries(model).find((entry) => entry.neutral);
            populateColors(model);
            if (neutral) applyOriginalChoice(neutral);
            else setText(status, model ? strings.keepSelection : strings.retainedSelection);
          });
          colorSelect.addEventListener('change', () => {
            applyOriginalChoice(entries.find((entry) => entry.model === modelSelect.value && entry.color === colorSelect.value));
          });
        }
        const selected = entries.find((entry) => entry.original === select.options[select.selectedIndex]);
        populateModels(selected ? selected.model : '');
        if (selected && modelSelect.value === selected.model) populateColors(selected.model, selected.color);
        setText(status, strings.retainedSelection);
      };
      select.addEventListener('change', () => refresh(true));
      guides.set(field, { select, details, refresh });
      refresh();
    };

    const installGuides = () => {
      main.querySelectorAll('.gpo-element select').forEach(addChoiceGuide);
    };

  const moveTrustStrip = () => {
    const trust = main.querySelector('.maxsports-trust-strip');
    const form = main.querySelector('.product-form');
    if (trust && form && trust.nextElementSibling !== form) {
      form.parentNode.insertBefore(trust, form);
    }
  };


  sticky = document.createElement('div');
  sticky.className = 'maxsports-sticky-atc';
  sticky.hidden = true;
  sticky.inert = true;
  sticky.setAttribute('aria-hidden', 'true');
  sticky.innerHTML =
    '<div class="maxsports-sticky-atc__meta">' +
      '<span class="maxsports-sticky-atc__title"></span>' +
      '<span class="maxsports-sticky-atc__price"></span>' +
      '<span class="maxsports-sticky-atc__quantity" hidden></span>' +
    '</div>' +
    '<button class="maxsports-sticky-atc__button" type="button" disabled>' + strings.addToCart + '</button>';
  document.body.appendChild(sticky);

  const stickyTitle = sticky.querySelector('.maxsports-sticky-atc__title');
  const stickyPrice = sticky.querySelector('.maxsports-sticky-atc__price');
  const stickyQuantity = sticky.querySelector('.maxsports-sticky-atc__quantity');
  const stickyButton = sticky.querySelector('.maxsports-sticky-atc__button');

  const currentButton = () =>
    Array.from(main.querySelectorAll('.product-form__submit')).find(isRendered);

  const canonicalButton = (visibleButton) => {
    const productForm = visibleButton && visibleButton.closest('product-form') || main.querySelector('product-form');
    if (!productForm) return visibleButton;
    const marked = productForm.querySelector('.gpo-original-atc-button');
    const original = marked && (marked.matches('button') ? marked : marked.querySelector('.product-form__submit'));
    if (original) return original;
    if (productForm.submitButton && productForm.contains(productForm.submitButton)) return productForm.submitButton;
    return productForm.querySelector('.product-form__submit:not(.gpo-clone-atc-button)') || visibleButton;
  };

  const buttonUnavailable = (button) =>
    !button || button.disabled || button.getAttribute('aria-disabled') === 'true';

  const cloneLocks = new WeakMap();
  const cloneDisabledWrites = new WeakMap();
  const cloneOwners = new Map();
  let nextCloneOwner = 0;

  const cloneOwner = (clone, appDisabled) => {
    let id = clone.getAttribute('data-maxsports-availability-owner');
    if (!id) {
      do { id = 'ux-' + ++nextCloneOwner; } while (cloneOwners.has(id));
    }
    if (!cloneOwners.has(id)) cloneOwners.set(id, { id, appDisabled });
    return cloneOwners.get(id);
  };

  recordCloneMutations = (mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type !== 'attributes' || mutation.attributeName !== 'disabled') return;
      const lock = cloneLocks.get(mutation.target);
      if (!lock) {
        if (mutation.target.matches('.gpo-clone-atc-button')) {
          cloneDisabledWrites.set(mutation.target, mutation.target.disabled);
        }
        return;
      }
      if (lock.ownedWrites) lock.ownedWrites -= 1;
      else {
        lock.appDisabled = mutation.target.disabled;
        lock.owner.appDisabled = lock.appDisabled;
        setAttribute(mutation.target, 'data-maxsports-availability-app-disabled', lock.appDisabled ? 'true' : 'false');
      }
    });
  };

  const setCloneDisabled = (clone, lock, disabled) => {
    if (clone.disabled === disabled) return;
    lock.ownedWrites += 1;
    clone.disabled = disabled;
  };

  const syncCloneAvailability = () => {
    main.querySelectorAll('.gpo-clone-atc-button').forEach((element) => {
      const clone = element.matches('button') ? element : element.querySelector('.product-form__submit, button');
      if (!clone) return;
      const canonical = canonicalButton(clone);
      let lock = cloneLocks.get(clone);
      const label = clone.querySelector(':scope > span:not([aria-hidden="true"])') || clone;
      if (!lock && clone.getAttribute('data-maxsports-availability-lock') === 'true') {
        const owner = cloneOwner(clone, clone.getAttribute('data-maxsports-availability-app-disabled') === 'true');
        lock = { owner, appDisabled: owner.appDisabled, ownedDisabled: true, ownedWrites: 0,
          label, ownedText: label.textContent.trim() };
        cloneLocks.set(clone, lock);
      }
      if (lock) lock.appDisabled = lock.owner.appDisabled;
      if (canonical && canonical !== clone && buttonUnavailable(canonical)) {
        if (!lock) {
          const inheritedStock = clone.disabled && canonical.disabled &&
            clone.getAttribute('disabled') === canonical.getAttribute('disabled') &&
            clone.innerHTML === canonical.innerHTML && !clone.classList.contains('gpo-loading') &&
            !clone.classList.contains('loading') && clone.getAttribute('aria-disabled') !== 'true' &&
            cloneDisabledWrites.get(clone) !== true;
          const owner = cloneOwner(clone, clone.disabled && !inheritedStock);
          lock = { owner, appDisabled: owner.appDisabled, ownedDisabled: inheritedStock, ownedWrites: 0,
            label, ownedText: '' };
          cloneLocks.set(clone, lock);
        } else if (lock.label !== label) {
          lock.label = label;
        }
        if (!clone.disabled) lock.ownedDisabled = true;
        setCloneDisabled(clone, lock, true);
        setAttribute(clone, 'data-maxsports-availability-lock', 'true');
        setAttribute(clone, 'data-maxsports-availability-owner', lock.owner.id);
        setAttribute(clone, 'data-maxsports-availability-app-disabled', lock.appDisabled ? 'true' : 'false');
        lock.ownedText = canonical.textContent.trim();
        setText(label, lock.ownedText);
      } else if (lock) {
        const busy = clone.classList.contains('gpo-loading') || clone.classList.contains('loading') ||
          clone.getAttribute('aria-disabled') === 'true';
        if (lock.ownedDisabled && !lock.appDisabled && !busy) setCloneDisabled(clone, lock, false);
        if (lock.label.isConnected && lock.label.textContent.trim() === lock.ownedText && canonical) {
          setText(lock.label, canonical.textContent.trim());
        }
        if (lock.ownedDisabled && !lock.appDisabled && busy) return;
        clone.removeAttribute('data-maxsports-availability-lock');
        clone.removeAttribute('data-maxsports-availability-app-disabled');
        clone.removeAttribute('data-maxsports-availability-owner');
        cloneLocks.delete(clone);
        if (!Array.from(main.querySelectorAll('[data-maxsports-availability-owner]'))
          .some((element) => element.getAttribute('data-maxsports-availability-owner') === lock.owner.id)) {
          cloneOwners.delete(lock.owner.id);
        }
      }
    });
  };

  const currentPrice = (productRoot) => {
    const price = Array.from(productRoot.querySelectorAll('[id^="price-"] .price')).find(isRendered);
    if (!price) return '';
    const selector = price.classList.contains('price--on-sale')
      ? '.price__sale .price-item--sale'
      : '.price__regular .price-item--regular';
    const active = Array.from(price.querySelectorAll(selector)).find(isRendered);
    return active ? active.textContent.trim() : '';
  };

  const currentQuantity = (original) => {
    const form = original && original.closest('form');
    return form && Array.from(form.elements).find((element) => element.name === 'quantity');
  };

  const buttonInViewport = (button) => {
    if (!button) return false;
    const rect = button.getBoundingClientRect();
    const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    return rect.width > 0 && rect.height > 0 && visibleHeight >= rect.height * 0.15 &&
      rect.right > 0 && rect.left < window.innerWidth;
  };

  syncProduct = (overlayOpen) => {
    syncStringStock();
    syncCloneAvailability();
    if (mobile.matches) {
      installGuides();
      moveTrustStrip();
    }
    const original = currentButton();
    const canonical = canonicalButton(original);
    const productRoot = original && original.closest('product-info') || main;
    const title = productRoot.querySelector('.product__title h1');
    const quantity = currentQuantity(original);
    const quantityValue = quantity ? quantity.value.trim() : '1';
    const quantityLabel = productRoot.querySelector('.quantity__label [aria-hidden="true"]');

    setText(stickyTitle, title ? title.textContent.trim() : '');
    setText(stickyPrice, currentPrice(productRoot));
    setText(stickyQuantity, '× ' + quantityValue);
    if (quantityLabel) setAttribute(stickyQuantity, 'aria-label', quantityLabel.textContent.trim() + ': ' + quantityValue);
    const showQuantity = Boolean(quantity && quantityValue !== '1');
    if (stickyQuantity.hidden !== !showQuantity) stickyQuantity.hidden = !showQuantity;
    const labelButton = buttonUnavailable(canonical) ? canonical : original;
    setText(stickyButton, labelButton ? labelButton.textContent.trim() : strings.addToCart);

    const shouldShow = mobile.matches && window.scrollY > 220 && Boolean(original) &&
      !buttonInViewport(original) && !overlayOpen;
    if (!shouldShow && !sticky.hidden && sticky.contains(document.activeElement) && !overlayOpen && original) {
      original.focus({ preventScroll: true });
    }
    if (sticky.hidden !== !shouldShow) sticky.hidden = !shouldShow;
    if (sticky.inert !== !shouldShow) sticky.inert = !shouldShow;
    setClass(sticky, 'is-visible', shouldShow);
    setAttribute(sticky, 'aria-hidden', shouldShow ? 'false' : 'true');
    const disabled = !shouldShow || buttonUnavailable(original) || buttonUnavailable(canonical);
    if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
  };

  stickyButton.addEventListener('click', () => {
    const original = currentButton();
    if (!sticky.hidden && !stickyButton.disabled && !buttonUnavailable(original) &&
      !buttonUnavailable(canonicalButton(original)) && !themeOverlayOpen()) original.click();
  });

  main.addEventListener('change', scheduleSync);
  main.addEventListener('input', scheduleSync);
  main.addEventListener('click', (event) => {
    const clone = event.target.closest && event.target.closest('.gpo-clone-atc-button');
    if (clone && buttonUnavailable(canonicalButton(clone))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      scheduleSync();
    }
  }, true);
  }

  const observer = new MutationObserver((mutations) => {
    recordCloneMutations(mutations);
    if (mutations.some((mutation) => !sticky ||
      !(mutation.target === sticky || sticky.contains(mutation.target)))) scheduleSync();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'open', 'hidden', 'style', 'aria-disabled', 'disabled', 'aria-modal', 'gpo-data-variant-id', 'data-option-set-id', 'data-element-id', 'value']
  });

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  mobile.addEventListener('change', scheduleSync);
  document.addEventListener('toggle', scheduleSync, true);
  document.addEventListener('shopify:section:load', scheduleSync);
  document.body.addEventListener('modalClosed', scheduleSync);
  if (window.ResizeObserver && sticky) new ResizeObserver(scheduleSync).observe(sticky);
  sync();
})();
